// extracted by mini-css-extract-plugin
module.exports = {"grid":"hotel_name_address_grid__22zMz","name":"hotel_name_address_name__N7aFy","address":"hotel_name_address_address__21FOD","timespan":"hotel_name_address_timespan__17zNg"};